// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","wrapper":"ReferralSection_wrapper__WTeQL","container":"ReferralSection_container__WmtnX"};